__turbopack_context__.v({
  "stripeLogo": "XplnyW_stripeLogo",
});
